module.exports = __webpack_public_path__ + "static/media/portada.44719b62.png";